import { registerPushSubscription } from "./api";

function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');
 
  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);
 
  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}


export async function registerForPushNotifications() {
  const { REACT_APP_PUSH_PUBLIC_KEY } = process.env;
  const applicationServerKey = urlBase64ToUint8Array(REACT_APP_PUSH_PUBLIC_KEY);
  const { serviceWorker } = navigator;
  const { pushManager } = await serviceWorker.ready;
  const pushSubscription = await pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  });
  // FIXME: do POST only if needed
  await registerPushSubscription(pushSubscription);
}
